<modal-form-container
  title="Add tags"
  className="md:w-[720px] lg:w-[760px]"
  [showModal]="open"
  (closeModalEvent)="closeModal()"
>
  @if (open) {
    <div class="gm">
      <p class="gm__lead">Choose the tags to add to <strong>{{ contactLabel }}</strong>.</p>

      <bk-group-picker kind="tag" [selected]="selectedTags" (selectedChange)="onPick($event)" />

      @if (errorMsg) {
        <p class="gm__error" role="alert"><span class="bk-sym" aria-hidden="true">error</span>{{ errorMsg }}</p>
      }

      <div class="gm__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="closeModal()">Cancel</button>
        <button
          type="button"
          class="bk-btn bk-btn--primary"
          [disabled]="!selectedTags.length || saving"
          (click)="handleSubmit()"
        >
          {{ submitLabel }}
        </button>
      </div>
    </div>
  }
</modal-form-container>
